import { apiClient } from "@api/client";
import { request } from "@api/request";

export const artifactsClient = {
  getDownloadUrl: (id: string) =>
    request(() =>
      apiClient.GET("/artifacts/{artifact_uuid}", {
        params: { path: { artifact_uuid: id } },
      }),
    ).then((res) => res.download_url),
};
